import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, ArrowRight, Info, Globe, Mail, Shield, Network } from 'lucide-react';
import api from '../api';
import AntoraSymbol from '../components/AntoraSymbol';

export default function Login() {
  const [u, setU] = useState('admin');
  const [p, setP] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!p) return;
    setErr('');
    setLoading(true);
    try {
      const { data } = await api.post('/login', { username: u, password: p });
      localStorage.setItem('tguth_token', data.token);
      nav('/dashboard');
    } catch (e) {
      setErr(e.response?.data?.error || 'Erro no login');
    } finally {
      setLoading(false);
    }
  };

  const features = [
    { icon: Globe,   label: 'DNS · DNSSEC · Reverso' },
    { icon: Mail,    label: 'E-mail completo' },
    { icon: Shield,  label: 'RPKI delegado' },
    { icon: Network, label: 'BGP · Geofeed RFC 8805' },
  ];

  return (
    <div className="login-page">
      <aside className="login-brand-side">
        <header className="hrow" style={{ gap: 12, zIndex: 1, position: 'relative' }}>
          <AntoraSymbol size={36}/>
          <div>
            <div className="brand-name" style={{ fontSize: 18 }}>antora<span style={{ color: 'var(--accent)' }}>.</span></div>
            <div className="brand-sub">Services</div>
          </div>
        </header>

        <div className="login-hero">
          <span className="login-eyebrow">
            <span className="dot ok pulse"/>Plataforma Operacional
          </span>
          <h1 className="login-headline">
            Infraestrutura<br/>
            <span className="accent">conectada por completo.</span>
          </h1>
          <p className="login-subhead">
            DNS autoritativo, e-mail, RPKI, Geofeed e roteamento BGP em uma única superfície.
            Confiabilidade de NOC, ergonomia de produto.
          </p>

          <div className="login-features">
            {features.map((f, i) => (
              <div key={i} className="login-feature">
                <f.icon size={14} color="var(--accent)"/>
                <span style={{ fontWeight: 500 }}>{f.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="login-foot">v2.4.0 · build 20260521 · © Antora Services</div>
      </aside>

      <main className="login-form-side">
        <div className="login-card stack-lg">
          <div>
            <h2 className="h1" style={{ marginBottom: 6 }}>Acesse o painel</h2>
            <p className="dim" style={{ fontSize: 14 }}>Use suas credenciais para continuar.</p>
          </div>

          <form onSubmit={submit} className="stack">
            <div className="field">
              <label htmlFor="login-user">Usuário</label>
              <input id="login-user" className="input" type="text" value={u}
                onChange={e => setU(e.target.value)} placeholder="admin"
                autoComplete="username" required autoFocus/>
            </div>

            <div className="field">
              <div className="row-between">
                <label htmlFor="login-pass" style={{ margin: 0 }}>Senha</label>
              </div>
              <div style={{ position: 'relative' }}>
                <input id="login-pass" className="input" type={showPass ? 'text' : 'password'}
                  value={p} onChange={e => setP(e.target.value)}
                  placeholder="••••••••" autoComplete="current-password" required
                  style={{ paddingRight: 38 }}/>
                <button type="button" onClick={() => setShowPass(v => !v)}
                  className="btn btn-icon btn-ghost"
                  style={{ position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)' }}>
                  {showPass ? <EyeOff size={15}/> : <Eye size={15}/>}
                </button>
              </div>
            </div>

            {err && <div className="err-msg">{err}</div>}

            <button type="submit" className="btn btn-primary" disabled={loading}
              style={{ padding: '11px 14px', fontSize: 14 }}>
              {loading
                ? <>Autenticando<span style={{ opacity: 0.5 }}>…</span></>
                : <>Entrar no painel <ArrowRight size={14}/></>}
            </button>
          </form>

          <div style={{ padding: 14, background: 'var(--bg)', border: '1px solid var(--border)',
                        borderRadius: 'var(--radius)', fontSize: 12, color: 'var(--text-dim)',
                        display: 'flex', gap: 10 }}>
            <Info size={16} color="var(--info)" style={{flexShrink:0}}/>
            <div>
              <div style={{ fontWeight: 600, color: 'var(--text)', marginBottom: 2 }}>Acesso seguro</div>
              Sessões expiram após inatividade. Auditoria completa de operações.
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
